import DataLoader from "../Utlis/DataLoader";

async function Addcomment(requestBody) { 
  try {
    const response = await DataLoader({
      Path: '/api/v1/comments/Addcomment/',
      Type: 'post',
      requestBody: requestBody
    });
    return response;
  } catch (error) {
        throw error;
  }
}

export default Addcomment;
